import React from 'react'

import { bool } from 'prop-types'

import RedesignedOverviewTab from './RedesignedOverviewTab'

function OverviewTab({ isSubscriptionParticipant = false, payoutRateArticleLink = false }) {
  return (
    <RedesignedOverviewTab
      isSubscriptionParticipant={isSubscriptionParticipant}
      payoutRateArticleLink={payoutRateArticleLink}
    />
  )
}

OverviewTab.propTypes = {
  isSubscriptionParticipant: bool,
  payoutRateArticleLink: bool,
}

export default OverviewTab
